export const PATIENT_ADDRESS_FIELDS = [
  "street_address_1",
  "city",
  "state",
  "zip_code"
] as const;

export type PatientAddressFields = Partial<
  Record<(typeof PATIENT_ADDRESS_FIELDS)[number], string | null | undefined>
>;

/**
 * True when any of the four primary address fields carries a non-blank value.
 * ENG-1912: a record with even a lone ZIP counts as "has an address" — the web-booking
 * address is only ever offered for a record that has none at all.
 */
export function hasAnyAddress(
  record: PatientAddressFields | null | undefined
): boolean {
  if (!record) return false;
  return PATIENT_ADDRESS_FIELDS.some((field) =>
    Boolean((record[field] ?? "").trim())
  );
}

/** "street\ncity, state zip" for display; omits whatever is missing. */
export function formatWebAddress(
  record: PatientAddressFields | null | undefined
): string {
  if (!record) return "";
  const street = (record.street_address_1 ?? "").trim();
  const city = (record.city ?? "").trim();
  const stateZip = [record.state, record.zip_code]
    .map((part) => (part ?? "").trim())
    .filter(Boolean)
    .join(" ");
  const secondLine = [city, stateZip].filter(Boolean).join(", ");
  return [street, secondLine].filter(Boolean).join("\n");
}
